import "core-js/modules/es.array.iterator.js";
import React from 'react';
import clsx from 'clsx';
import { useOverflowObserver } from "../../../../../hooks";
import { useSpring, config } from '@react-spring/web';
import { NavigationDirection } from "./navigation.vm";
import { Ripple } from "../../../transition";
import '@isyc-react/design/main';
import "./navigation-arrows.style.scss";
const navigatePressInterval = 100;
export const NavigationArrows = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    watch,
    children
  } = props;
  const {
    overflowX
  } = useOverflowObserver(watch);
  const overflowXref = React.useRef(false);
  const pressTimerRef = React.useRef(null);
  const [, api] = useSpring(() => ({
    x: 0,
    config: config.stiff
  }));
  React.useEffect(() => {
    if (overflowX !== undefined) overflowXref.current = overflowX;
  }, [overflowX]);
  React.useEffect(() => {
    if (watch.current) {
      watch.current.style.overflowX = 'hidden';
      watch.current.addEventListener('wheel', e => {
        if (watch.current && overflowXref.current) {
          const delta = Math.abs(e.deltaY);
          if (e.deltaY > 0) watch.current.scrollLeft += delta;else watch.current.scrollLeft -= delta;
          e.preventDefault();
        }
      });
    }
  }, []);
  const scroll = React.useCallback((offset, animation) => {
    if (watch.current) {
      api.start({
        x: offset,
        reset: true,
        from: {
          x: watch.current.scrollLeft
        },
        config: animation !== null && animation !== void 0 ? animation : config.stiff,
        onChange: offset => {
          if (watch.current) {
            watch.current.scrollLeft = offset.value.x;
          }
        }
      });
    }
  }, [watch]);
  const navigate = React.useCallback((direction, offset, animation) => {
    if (watch.current) {
      const factor = direction === NavigationDirection.LEFT ? -1 : 1;
      const currentOffset = offset !== null && offset !== void 0 ? offset : watch.current.offsetWidth * 0.75;
      const scrollOffset = watch.current.scrollLeft + currentOffset * factor;
      scroll(scrollOffset, animation);
    }
  }, [watch, scroll]);
  const scrollTo = React.useCallback((target, animation, container) => {
    var _ref;
    const children = (_ref = container !== null && container !== void 0 ? container : watch.current) === null || _ref === void 0 ? void 0 : _ref.children;
    if (overflowX && children) {
      let offset = 0;
      let stop = false;
      for (let i = 0; i < children.length && !stop; i++) {
        let child = children[i];
        if (child.contains(target)) stop = true;else offset += child.offsetWidth;
      }
      scroll(offset, animation);
    }
  }, [watch, overflowX, scroll]);
  const onStartPressNavigate = React.useCallback(direction => {
    pressTimerRef.current = setInterval(() => {
      navigate(direction, 40, {
        duration: navigatePressInterval
      });
    }, navigatePressInterval);
  }, [navigate]);
  const onStopPressNavigate = React.useCallback(() => {
    if (pressTimerRef.current) clearInterval(pressTimerRef.current);
  }, []);
  React.useImperativeHandle(ref, () => ({
    scrollTo,
    scroll,
    navigate
  }), [scrollTo, scroll, navigate]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('overflow-arrows-container', {
      'overflow-x': overflowX
    })
  }, overflowX && /*#__PURE__*/React.createElement("div", {
    className: "overflow-x-arrow overflow-x-arrow-left",
    onClick: () => navigate(NavigationDirection.LEFT),
    onMouseDown: () => onStartPressNavigate(NavigationDirection.LEFT),
    onMouseUp: () => onStopPressNavigate(),
    onMouseLeave: () => onStopPressNavigate()
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-ripple overflow-x-arrow-button"
  }, /*#__PURE__*/React.createElement(Ripple, {
    colorClassName: "overflow-x-arrow-button-ripple"
  }), /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-left"
  }))), /*#__PURE__*/React.createElement(React.Fragment, null, children), overflowX && /*#__PURE__*/React.createElement("div", {
    className: "overflow-x-arrow overflow-x-arrow-right",
    onClick: () => navigate(NavigationDirection.RIGHT),
    onMouseDown: () => onStartPressNavigate(NavigationDirection.RIGHT),
    onMouseUp: () => onStopPressNavigate(),
    onMouseLeave: () => onStopPressNavigate()
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-ripple overflow-x-arrow-button"
  }, /*#__PURE__*/React.createElement(Ripple, {
    colorClassName: "overflow-x-arrow-button-ripple"
  }), /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-right"
  })))));
});